import type { ISidebarGroup } from '@/lib/sidebar/getSidebarSections'
import { hasPermission } from '@/lib/auth/permissions'
import type { IUser } from '@/types/user'

export interface ISpotlightNavItem {
  title: string
  url: string
  path: string
}

type ISidebarListItem = ISidebarGroup['items'][number]

function buildPath(parentLabel: string, ...segments: string[]): string {
  return [parentLabel, ...segments].filter(Boolean).join('>')
}

function isItemVisible(item: ISidebarListItem, user: IUser): boolean {
  return !item.permission || hasPermission({ user, permission: item.permission })
}

function subItemsToSpotlightEntries(item: ISidebarListItem, parentLabel: string): ISpotlightNavItem[] {
  if (!item.items?.length) {
    return [{ title: item.title, url: item.url, path: buildPath(parentLabel, item.title) }]
  }
  return item.items.map((sub) => ({
    title: sub.title,
    url: sub.url,
    path: buildPath(parentLabel, item.title, sub.title),
  }))
}

function itemsFromGroup(group: ISidebarGroup, user: IUser): ISpotlightNavItem[] {
  const parentLabel = group.label ?? ''
  return group.items
    .filter((item) => isItemVisible(item, user))
    .flatMap((item) => subItemsToSpotlightEntries(item, parentLabel))
}

export function getSpotlightNavigationItems(groups: ISidebarGroup[], user: IUser): ISpotlightNavItem[] {
  return groups.flatMap((group) => itemsFromGroup(group, user))
}
